function setupSearchTriggers() {
    const header = document.querySelector("header");
    const searchTriggers = document.querySelectorAll(".js-searchTrigger");
    const searchBlock = document.querySelector(".js-searchBlock");
    const searchInput = searchBlock.querySelector(".js-searchInput");

    searchTriggers.forEach(function (searchTrigger) {
        searchTrigger.addEventListener("click", function () {
            searchInput.focus();
            header.classList.toggle("search-active");
            searchBlock.classList.contains("search-active")
                ? searchBlock.removeAttribute("aria-hidden")
                : searchBlock.setAttribute("aria-hidden", "true");
            searchTrigger.classList.toggle("active");
        });
    });
}

async function fetchSearchResults(pid, searchTerm) {
    const fetchBody = { Query: searchTerm, PageId: pid };
    const data = await fetch('/api/websitesearch/search/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(fetchBody),
    }).then((res) => res.json());

    console.log(data);

    const results = data.searchResults;

    // const results = Array(5).fill({
    //     title: "Search title goes here",
    //     description: `Lorem ipsum dolor sit amet,
    // consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
    // labore et dolore magna aliqua quis nostrud exercitation ullamco
    // Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
    // eiusmod tempor incididunt ut labore et dolore magna aliqua...`,
    //     link: "/link",
    // });

    return results;
}

function createSearchResults(results, container) {
    container.innerHTML = "";
    results.forEach(function (result) {
        const searchResultEl = document.createElement("div");
        searchResultEl.classList.add("search-result");
        searchResultEl.innerHTML = `
      <span class="search-result__label">Search Result</span>
        <h6 class="search-result__title">${result.title}</h6>
        <p class="search-result__description">${result.description}</p>
        <a class="search-result__link" href="${result.link}">Find out more</a>
      `;

        container.appendChild(searchResultEl);
    });
}

function handleSearchSubmit(
    pid,
    searchBlock,
    searchClose,
    searchSubmit,
    searchInput,
    searchTerm,
    searchCount,
    searchResultsList,
    searchResults
) {
    return async function () {
        if (!searchInput.value) return;

        searchClose.classList.remove("hidden");
        searchSubmit.classList.add("hidden");

        // Fetch results via AJAX
        const results = await fetchSearchResults(
            pid,
            searchInput.value
        );
        searchTerm.textContent = `"${searchInput.value}"`;
        searchCount.textContent = results.length;

        // Populate list of results
        createSearchResults(results, searchResultsList);

        searchResults.classList.add("active");
    };
}

function headerSearchInit() {
    const pid = document.querySelector("meta[name=pid]").getAttribute("content");
    const header = document.querySelector("header");
    const searchBlock = document.querySelector(".js-searchBlock");
    const searchResults = searchBlock.querySelector(".js-searchResults");
    const searchResultsList = searchBlock.querySelector(".js-searchResultsList");
    const searchInput = searchBlock.querySelector(".js-searchInput");
    const searchSubmit = searchBlock.querySelector(".js-searchSubmit");
    const searchClose = searchBlock.querySelector(".js-searchClose");

    const searchTerm = searchBlock.querySelector(".js-searchTerm");
    const searchCount = searchBlock.querySelector(".js-searchCount");

    searchBlock.style.height = `calc(100vh - ${header.offsetHeight}px - 1px)`;

    searchSubmit.addEventListener(
        "click",
        handleSearchSubmit(
            pid,
            searchBlock,
            searchClose,
            searchSubmit,
            searchInput,
            searchTerm,
            searchCount,
            searchResultsList,
            searchResults
        )
    );

    searchInput.addEventListener("keypress", function (e) {
        // Highlight submit if text
        if (this.value !== "") {
            searchSubmit.classList.add("active");
        } else {
            searchSubmit.classList.remove("active");
        }
        // Show submit button, hide close button
        searchSubmit.classList.remove("hidden");
        searchClose.classList.add("hidden");

        // Allow enter press to submit
        if (e.key === "Enter") {
            // Cancel the default action, if needed
            e.preventDefault();
            // Trigger the button element with a click
            searchSubmit.click();
        }
    });

    searchClose.addEventListener("click", function () {
        // Reset all elements - clear input, hide results
        searchInput.value = "";
        searchBlock.setAttribute("aria-hidden", true);
        searchSubmit.classList.remove("hidden");
        searchClose.classList.add("hidden");
        searchResults.classList.remove("active");
        searchSubmit.classList.remove("active");
    });
}

export default function () {
    setupSearchTriggers();
    headerSearchInit();
}
